<template>
  <div id="pagination" class="pager">
    <ul class="pagination">
      <li
        class="pre"
        :class="{'cursor-pointer': !isInFirstPage, inactive: isInFirstPage}"
        @click="isInFirstPage ? null : onClickPreviousPage()"
      >
        <a :class="{inactive: isInFirstPage}">
          <svg :class="{'icon-pre': !isInFirstPage, 'icon-pre-available' : isInFirstPage }" width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.25 10.5L1.75 6L6.25 1.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
      </li>

      <li
        v-for="(page, index) in pages"
        :key="index"
        :id="'page' + index"
        :class="{'cursor-pointer': !isPageActive(page) && page !== '...', 'point-event-none': isPageActive(page)}"
        @click="page === '...' ? null : onClickPage(page)"
      >
        <a :class="{ active: isPageActive(page), 'inactive':  page === '...'}">
          <span
            :aria-label="`Go to page number ${page}`"
          >
            {{ page }}
          </span>
        </a>
      </li>

      <li
        class="next"
        @click="isInLastPage ? null : onClickNextPage()"
        :class="{'cursor-pointer': !isInLastPage}"
      >
        <a :class="{inactive: isInLastPage}">
          <svg :class="{'icon-next': !isInLastPage, 'icon-next-available': isInLastPage}" width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.75 10.5L6.25 6L1.75 1.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: "Pagination",
  props: {
    maxVisibleButtons: {
      type: Number,
      required: false,
      default: 6
    },
    listItem: Array,
    // firstPagePath: String,
    totalItems: Number,
    page: Number
  },
  watch: {
    listItem(value) {
      if (value.length < 1) {
        // this.$emit('getLists');
      }
    },
    page(vale) {
      if (vale === 1) {
        this.currentPage = 1;
      }
    }
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  created() {
    if (Object.keys(this.$route.query).length > 0) {
      this.currentPage = parseInt(this.$route.query.page)
    }
  },
  computed: {
    ...mapGetters({
      // isSearchWithPaging: "general/isSearchWithPaging"
    }),
    totalPages() {
      return Math.ceil(this.totalItems / 10)
    },
    pages() {
      const currentPage = this.currentPage;
      const pageCount = this.totalPages;
      const visiblePagesCount = this.maxVisibleButtons;
      const visiblePagesThreshold = Math.floor((visiblePagesCount - 1) / 2);
      let pagintationTriggersArray = Array(visiblePagesCount - 2).fill(0)
      if (pageCount > visiblePagesCount) {
        if (currentPage <= visiblePagesThreshold + 1) {
          pagintationTriggersArray[0] = 1
          const pagintationTriggers = pagintationTriggersArray.map(
            (paginationTrigger, index) => {
              return pagintationTriggersArray[0] + index
            }
          )
          pagintationTriggers.push('...')
          pagintationTriggers.push(pageCount)
          return pagintationTriggers
        }

        if (currentPage > pageCount - visiblePagesThreshold - 1) {
          const pagintationTriggers = pagintationTriggersArray.map(
            (paginationTrigger, index) => {
              return pageCount - index
            }
          )
          pagintationTriggers.reverse().unshift('...');
          pagintationTriggers.unshift(1);
          return pagintationTriggers
        }
        pagintationTriggersArray[0] = currentPage - visiblePagesThreshold + 1
        const pagintationTriggers = pagintationTriggersArray.map(
          (paginationTrigger, index) => {
            return pagintationTriggersArray[0] + index
          }
        )

        pagintationTriggers.unshift('...');
        pagintationTriggers.unshift(1);
        pagintationTriggers.push(pageCount);
        pagintationTriggers[pagintationTriggers.length - 1] = pageCount;
        pagintationTriggers[pagintationTriggers.length - 2] =  '...';
        return pagintationTriggers;
      } else {
        pagintationTriggersArray = Array(pageCount).fill(0)
        pagintationTriggersArray[0] = 1;
        return pagintationTriggersArray.map(
          (paginationTrigger, index) => {
            return pagintationTriggersArray[0] + index
          }
        );
      }
    },
    isInFirstPage() {
      return this.currentPage === 1;
    },
    isInLastPage() {
      if (this.totalPages === 0) {
        return this.currentPage - 1 === this.totalPages
      }
      return this.currentPage === this.totalPages;
    },
  },
  methods: {
    onClickPreviousPage() {
      this.currentPage -= 1;
      this.$emit('paging', this.currentPage)
    },
    onClickPage(page) {
      this.currentPage = page
      this.$emit('paging', this.currentPage)
    },
    onClickNextPage() {
      this.currentPage += 1;
      this.$emit('paging', this.currentPage)
    },
    isPageActive(page) {
      return this.currentPage === page;
    },
  }
}
</script>

<style lang="scss" scoped>
.inactive {
  cursor: unset;
  color: #666666;
}
.inactive:hover {
  color: #666666 !important;
  background-color: white !important;
}
.cursor-pointer {
  cursor: pointer;
}
.point-event-none {
  pointer-events: none;
}
.pager {
  width: 100%;
  height: 51px;
  padding: 10px;
  border-bottom: 1px solid #EEEEEE;
  margin-top: -20px;
  margin-bottom: 10px;
}
.pager ul.pagination {
  width: 100%;
  height: 100%;
  text-align: center;
  padding: 0;
  display: block;
  margin-bottom: 10px;
}
.pager .pagination li {
  width: 30px;
  height: 30px;
  text-align: center;
  background: #FFFFFF;
  display: inline-block;
  margin: 0 2px;
  padding: 0;
  position: relative;
  border-radius: 10px;
}
.pager .pagination li a {
  width: 95%;
  height: 95%;
  position: absolute;
  /*top: 0;*/
  left: 0;
  display: table;
  text-decoration: none;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: #8D8282;
}
.pager .pagination li a span {
  font-size: 13px;
  line-height: 26px;
  text-align: center;
}
.pager .pagination li a:hover,
.pager .pagination li a.active{
  background: #2183DD;
  border-radius: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  color: #FFFFFF;
}
.pre,
.next {
  border: none;
}
.pre a,
.next a {
  margin-top: 5px;
  top: -5px;
}
.icon-pre,
.icon-pre-available {
  top: 6px;
  position: absolute;
  left: 10px;
}
.icon-pre path,
.icon-next path{
  stroke: #2183DD;
}
.icon-pre-available path,
.icon-next-available path{
  stroke: #8D8282;
}
.icon-next,
.icon-next-available {
  top: 6px;
  position: absolute;
  right: 10px;
}

.pre a:hover,
.next a:hover {
  .icon-next path,
  .icon-pre path {
    stroke: #FFFFFF;
  }
}
</style>